import { Environment, Metadata, Plan } from '@workspaces/types'
import { UserPermissions } from '../permissions.manager.type'
import ResolverBasic from './resolver-basic'
/**
 * 📢 No roles are defined
 */
class PermissionResolver extends ResolverBasic implements UserPermissions {
  canUploadCustomPOIs(): boolean {
    return true
  }

  canEditAnyCustomPOIGroup(): boolean {
    return false
  }

  public canSavePlan(plan: Plan.Plan): boolean {
    const planId = plan.id
    if (!planId) {
      return true
    }
    const planOwner = plan.created_by
    return this.getName() === planOwner
  }

  canSavePlanAsPublic(): boolean {
    return true
  }

  canDeletePlan(plan: Plan.Plan): boolean {
    const planOwner = plan.created_by
    return this.getName() === planOwner
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canDeleteCustomGeoboundary(owner: string): boolean {
    return false
  }

  canDeleteCustomPOIGroup(owner: string): boolean {
    return this.isOwnerOrAdmin(owner)
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canUpdateCustomPOIGroup(owner: string): boolean {
    return this.isOwnerOrAdmin(owner)
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canAdminEditPlan(plan: Plan.Plan): boolean {
    return false
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canEditPlanPrice(plan: Plan.Plan): boolean {
    return false
  }

  canShowWidgetUploadAssets(): boolean {
    return true
  }

  canAccessCustomizationByCountry(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    metadata: Metadata.AppMetadata,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    environment: Environment.EnvironmentResolver,
  ): boolean {
    return false
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canChangePlanOwner(plan: Plan.Plan): boolean {
    return false
  }

  canSeeAllPlans(): boolean {
    return false
  }
}

export default PermissionResolver
